<template>
  <tr class="urgency-list__card" :class="{complete: status == 'complete', error: status == 'error'}">
    <td data-title="Тип">
        <input type="text" v-model="item.name">
    </td>
    <td class="text-right urgency-list__check-btn">
      <button
        type="button"
        class="button-check"
        @click="onSave"
        :disabled="status == 'pending'"
      ></button>
    </td>
    <td class="text-right urgency-list__delete-btn">
      <button
        type="button"
        class="button-delete"
        @click="onRemove"
        :disabled="status == 'pending'"
      ></button>
    </td>
  </tr>
</template>

<script>
export default {
  data: function() {
    return {
      item: this.data,
      status: null
    };
  },

  props: {
    data: {
      type: Object,
      require: true
    },
    removeCallback: {
      type: Function,
      require: true
    }
  },

  methods: {
    create: function() {
      const t = this;
      axios
        .post("/urgency-type", {
          name: this.item.name
        })
        .then(function(response) {
          const id = response.data.id;
          t.item.id = id;
          t.status = "complete";
        })
        .catch(function(error) {
          t.status = "error";
          console.error(error);
        });
    },

    update: function() {
      const t = this;
      axios
        .put("/urgency-type/" + this.item.id, {
          name: this.item.name
        })
        .then(function() {
          t.status = "complete";
        })
        .catch(function(error) {
          t.status = "error";
          console.error(error);
        });
    },

    remove: function() {
      const t = this;
      axios
        .delete("/urgency-type/" + this.item.id)
        .then(function(response) {
          t.removeCallback(t.item);
          t.status = "complete";
        })
        .catch(function(error) {
          t.status = "error";
          console.error(error);
        });
    },

    onSave: function() {
      this.status = "pending";

      if (this.item.id) {
        this.update();
      } else {
        this.create();
      }
    },

    onRemove: function() {
      this.status = "pending";

      if (this.item.id) {
        this.remove();
      } else {
        this.removeCallback(this.item);
      }
    }
  }
};
</script>

<style scoped>
.error {
  animation: error 1s 1 ease-in-out;
}

.complete {
  animation: complete 1s 1 ease-in-out;
}

@keyframes error {
  from {
    background-color: #f2dede;
  }
  to {
    background-color: transparent;
  }
}

@keyframes complete {
  from {
    background-color: #dff0d8;
  }
  to {
    background-color: transparent;
  }
}
</style>
